// extracted by mini-css-extract-plugin
export var appsImages = "SocialAndAppsSection-module--appsImages--40359";
export var button = "SocialAndAppsSection-module--button--52ff1";
export var download = "SocialAndAppsSection-module--download--0a0dc";
export var facebook = "SocialAndAppsSection-module--facebook--2991c";
export var icon = "SocialAndAppsSection-module--icon--529cf";
export var instagram = "SocialAndAppsSection-module--instagram--3d26c";
export var link = "SocialAndAppsSection-module--link--bcc45";
export var linksContainer = "SocialAndAppsSection-module--linksContainer--00f9d";
export var pinterest = "SocialAndAppsSection-module--pinterest--3c225";
export var secondary = "SocialAndAppsSection-module--secondary--6eac0";
export var section = "SocialAndAppsSection-module--section--8c128";
export var share = "SocialAndAppsSection-module--share--719ab";
export var shareContent = "SocialAndAppsSection-module--shareContent--e5571";
export var shareImage = "SocialAndAppsSection-module--shareImage--c32ab";
export var socialContent = "SocialAndAppsSection-module--socialContent--f206b";
export var socialContentDesc = "SocialAndAppsSection-module--socialContentDesc--7b146";
export var socialHead = "SocialAndAppsSection-module--socialHead--99dfc";
export var socialHeadContent = "SocialAndAppsSection-module--socialHeadContent--0e45a";
export var socialHeadIcon = "SocialAndAppsSection-module--socialHeadIcon--dde94";
export var socialHeadTitle = "SocialAndAppsSection-module--socialHeadTitle--8ff79";
export var socialHeadWithIcon = "SocialAndAppsSection-module--socialHeadWithIcon--b271b";
export var socialLink = "SocialAndAppsSection-module--socialLink--51b60";
export var twitter = "SocialAndAppsSection-module--twitter--b502c";
export var youtube = "SocialAndAppsSection-module--youtube--52ec7";